<template>
  <Box>
    <div class="main-container">
      <div class="infos">
        <div class="infos-header">
          <p>{{ title }}</p>
          <span>{{ value }}</span>
        </div>

        <div>
          <Button text="Download relatório" color="primary" @handle:click="$emit('download')">
            <DownloadOutline :size="18" />
          </Button>
        </div>
      </div>

      <div class="icon" :class="color">
        <slot name="icon" />
      </div>
    </div>
  </Box>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import DownloadOutline from 'icons/DownloadOutline'

export default {
  name: 'ClassesCard',
  components: {
    Box,
    Button,
    DownloadOutline,
  },
  props: {
    title: String,
    value: [String, Number],
    color: {
      type: String,
      default: 'blue',
      validator: value => ['blue', 'red', 'orange'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.main-container {
  height: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;

  .infos {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;

    .infos-header {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      color: #202224;

      > p {
        margin: 0;
        font-weight: 600;
        font-size: 1.5rem;
      }

      > span {
        font-weight: 700;
        font-size: 1.75rem;
      }
    }
  }

  .icon {
    padding: 0.75rem;
    border-radius: 23px;

    &.blue {
      background-color: rgba(89, 135, 255, 0.21);
      color: #5987ff;
    }

    &.red {
      background-color: rgba(255, 35, 35, 0.21);
      color: #ff2323;
    }

    &.orange {
      background-color: rgba(255, 162, 14, 0.21);
      color: #ffa20e;
    }
  }
}
</style>
